import React from "react";
import FaIcon from "../Elements/FaIcon";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import JsxHelper from "../Helpers/JsxHelper";

export default class ApolloCustomTriggerItem {
  constructor(item) {
    if (item === undefined) {
      this.Id = "";
      this.SurveySassieId = "";
      this.QuestionId = "";
      this.QuestionValueIsNotEmpty = false;
      this.QuestionValue = "";
      this.UseQuestionIdAsEmailRecipient = false;
      this.EmailRecipients = "";
      this.WarningText = "Custom trigger warning";
      this.EmailSubject = "Custom trigger warning";
      this.Salutation = "Greetings";
      this.Closing = "Best regards";
      this.MySignature = "BARE IT Team";
      this.IsActive = "true";
      this.UseTable = "true";
      this.Response1 = "";
      this.Response2 = "";
      this.Response3 = "";
      this.Response1Description = "";
      this.Response2Description = "";
      this.Response3Description = "";
    } else {
      this.initialize(item);
    }
    // this.Notes=<>Useful codes:<br/>Question value field: exact value or {"{NotEmpty}"}.</>;
  }

  async initialize(item) {
    this.Id = item.id;
    this.SurveySassieId = item.surveySassieId;
    this.QuestionId = item.questionId;
    this.QuestionValueIsNotEmpty = item.questionValue === "{NotEmpty}";
    this.QuestionValue = item.questionValue.replace("{NotEmpty}", "");
    this.UseQuestionIdAsEmailRecipient = item.emailRecipients.includes("{") && item.emailRecipients.includes("}");
    this.EmailRecipients = item.emailRecipients.replace("{", "").replace("}", "");
    this.WarningText = item.warningText;
    this.EmailSubject = item.emailSubject;
    this.Salutation = item.salutation;
    this.Closing = item.closing;
    this.MySignature = item.mySignature;
    this.IsActive = item.isActive;
    this.UseTable = item.useTable;
    this.Response1 = item.response1 ? item.response1 : "";
    this.Response2 = item.response2 ? item.response2 : "";
    this.Response3 = item.response3 ? item.response3 : "";
    this.Response1Description = item.response1Description ? item.response1Description : "";
    this.Response2Description = item.response2Description ? item.response2Description : "";
    this.Response3Description = item.response3Description ? item.response3Description : "";
  }

  static NameOfTheIdField() {
    return "Id";
  }
  static nameOfTheItemDetailList() {
    return "Apollo Custom Trigger";
  }

  static MoneyFields = [];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = [];

  static BoolFields = ["IsActive"];

  static FieldsToShowInListTable = [
    {
      tabName: "Info",
      tabLabel: "Info",
      icon: "fa-solid fa-info",
      data: [
        { name: "Id", label: "Id" },
        { name: "SurveySassieId", label: "Survey SassieId" },
        { name: "QuestionId", label: "Question Id" },
        { name: "QuestionValue", label: "Question Value" },
        { name: "EmailRecipients", label: "Email Recipients" },
        { name: "EmailSubject", label: "Email Subject" },
        { name: "Salutation", label: "Salutation" },
        { name: "WarningText", label: "Email Body" },
        { name: "Closing", label: "Closing" },
        { name: "MySignature", label: "Signature" },
        { name: "IsActive", label: "Is Active" },
        { name: "UseTable", label: "Use Table" },
        { name: "Response1Description", label: "Response 1 Description" },
        { name: "Response1", label: "Response 1 Question Id" },
        { name: "Response2Description", label: "Response 2 Description" },
        { name: "Response2", label: "Response 2 Question Id" },
        { name: "Response3Description", label: "Response 3 Description" },
        { name: "Response3", label: "Response 3 Question Id" },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: "Id", orderById: "Id", data: "Id", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 50 },
      { label: "SurveySassieId", orderById: "SurveySassieId", data: "SurveySassieId", className: "text-center" },
      { label: "QuestionId", orderById: "QuestionId", data: "QuestionId", minWidth: 50, className: "text-center" },
      { label: "QuestionValue", orderById: "QuestionValue", data: "QuestionValue", minWidth: 50, className: "text-center" },
      { label: "EmailRecipients", orderById: "EmailRecipients", data: "EmailRecipients", minWidth: 20, className: "text-center" },
      { label: "Is Active", orderById: "IsActive", data: (item) => JsxHelper.YesNo(item.IsActive), className: "text-center" },
      { label: "Actions", orderById: "", data: ApolloCustomTriggerItem.getActionsContent, className: "text-center" },
    ];
  }

  static getActionsContent(item) {
    return (
      <div>
        <FaIcon iconName="fa-solid fa-edit" className="pointer link" tooltipText="Edit" onClick={() => ApolloCustomTriggerItem.editFunction(item.CaspianXextraApiQueryId, item)} />
      </div>
    );
  }

  static editFunction(id, item) {
    //this is just a placeholder
  }
}
